import React from "react";

// components
import Navbar from "../../components/Navbar";
import AdminSignIn from "../../components/AdminSignIn";
import FooterSection from "../../components/Footer";
import saveToApm from "../../apm";
import { useEffect} from "react";

const AdminSignInMainComponent = () => {
    useEffect(() => {
        saveToApm("Admin Sign In (/AdminSignIn)");
    }, []);
  return (
    <div>
      <Navbar />
      <AdminSignIn />
      <FooterSection />
    </div>
  );
};

export default AdminSignInMainComponent;
